define('app-SearchResults/main',['./modules/modules', './settings', 'async', 'underscore', '../app-Search/core/service'], function (modules, globalSettings, async, _, Service) {
    return {
        run: function () {
            if ($(globalSettings.overallContainer).length === 0) {
                window.log('No SEARCH RESULTS container located. Search results will not be available');
                return;
            }

            window.log('Loading SEARCH RESULTS app.');

            var tasks = [];

            // Initialise each module.
            _.each(modules, function (module) {
                tasks.push(function (callback) {
                    module.initialise(globalSettings);
                    callback(null);
                });
            });

            async.parallel(tasks);
            $(".filterButton").click(function () {
                if ($(window).width() < 922) {
                    $(".filterButton").toggleClass('active');
                    if ($(".filterButton").hasClass('active')) {
                        $('html').addClass('scrollFreeze');
                        $(".searchFacets").show();
                    }
                    else {
                        $('html').removeClass('scrollFreeze');
                        $(".searchFacets").hide();
                    }
                }
                else {
                    $(".searchFacets").slideToggle("slow", function () {
                        $(".filterButton").toggleClass('active');
                    });
                }
            });

            $('body').on('click', '#searchFacetsCruise label', function () {
                setTimeout(
                    function () {
                        if ($(window).width() < 922) {
                            $(".filterButton").toggleClass('active');
                            if ($(".filterButton").hasClass('active')) {
                                $('html').addClass('scrollFreeze');
                                $(".searchFacets").show();
                            }
                            else {
                                $('html').removeClass('scrollFreeze');
                                $(".searchFacets").hide();
                            }
                        }
                        else {
                            $(".searchFacets").slideToggle("slow", function () {
                                $(".filterButton").toggleClass('active');
                            });
                        }
                    }, 1000);
                var checked = $("#searchFacetsCruise input:checked").length;
                if ($(this).parent(li).find('input').is(':checked')) {
                    checked = checked - 1;
                }
                else {
                    checked = checked + 1;

                }
                if (checked > 0) {
                    $('.filterButton span').html(' (' + checked + ')');
                }
                else {
                    $('.filterButton span').html('');
                }
            });

            var service = new Service(globalSettings.searchStorageKey);
            $(".clearFilterButton").click(function () {
                service.removeAllOfType("bb");
                service.removeAllOfType("dp");
                service.removeAllOfType("du");
                service.removeAllOfType("os");
                service.removeAllOfType("rs");
                service.Notify();
            });

            $('#searchControl.searchResultsBar').css({ 'opacity': '100' });

            if ($(window).width() < 922) {
                if ($('#riverCruiseSearchButton:visible') || $('#oceanCruiseSearchButton:visible')) {
                    $("html, body").animate({ scrollTop: $("#searchResults").offset().top - 100 }, 1500);
                }; 
            };

        }
    };
});
